export default "__VITE_ASSET__40756e36__"